import { createClient, type SupabaseClient } from "@supabase/supabase-js";

// Dedicated client used ONLY to request a password-reset email.
// Implicit flow: no PKCE verifier is stored in this browser, so the emailed link
// works in whichever browser opens it (Gmail in-app browser, Safari, another device).
// Separate storage key and no persistence: it never touches the app's main session.
const SUPABASE_URL = "https://zlwvggnzyfldswpgebij.supabase.co";
const SUPABASE_PUBLISHABLE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inpsd3ZnZ256eWZsZHN3cGdlYmlqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzQxOTEwOTUsImV4cCI6MjA0OTc2NzA5NX0.8qWuWDK2TS87_mlOhXo1oj5CYerMK86LRDPnOF8WysE";

export const PASSWORD_RECOVERY_STORAGE_KEY = "sb-sokoby-password-recovery-request";

let recoveryClient: SupabaseClient | null = null;

export function getPasswordRecoveryClient(): SupabaseClient {
  if (!recoveryClient) {
    recoveryClient = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
      auth: {
        flowType: "implicit",
        storageKey: PASSWORD_RECOVERY_STORAGE_KEY,
        persistSession: false,
        autoRefreshToken: false,
        detectSessionInUrl: false,
      },
    });
  }
  return recoveryClient;
}
